<div
  class="alberta-button-input-wrapper"
  [ngClass]="{
    'alberta-button-input-wrapper--alert': ngControl && ngControl.invalid,
    'alberta-button-input-wrapper--disabled': disabled
  }"
  tappable
  [id]="freeTextInput ? null : uniqueTriggerId"
>
  <div class="button-content-wrapper">
    <div
      class="icon-wrapper"
      *ngIf="!noIcon"
      [ngClass]="{
        'icon-wrapper--stdIcon': !icon
      }"
    >
      <ion-icon [name]="icon ? icon : 'alberta-dot'"></ion-icon>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <div class="inputs-wrapper bold">
          <input
            *ngIf="freeTextInput; else defaultDatePicker"
            type="text"
            [maskito]="mask"
            placeholder="TT.MM.JJJJ"
            [(ngModel)]="dateString"
            (ngModelChange)="onDateChange()"
            class="date-wrapper font-bold"
            inputmode="decimal"
            [required]="required"
          />
          <ng-template #defaultDatePicker>
            <div>
              {{ date | date : dateFormatter }}
            </div>
          </ng-template>
        </div>
        <div
          class="deleteButton"
          (click)="removeInput($event)"
          *ngIf="date != undefined && !disabled && !noDeleteButton"
        >
          <ion-icon name="alberta-delete"></ion-icon>
        </div>
      </div>
      <div class="title">{{ title }} <span *ngIf="required" class="required-star">*</span></div>
    </div>
  </div>
  <div class="description" *ngIf="description">
    {{ description }}
  </div>
  <itl-error-display *ngIf="ngControl" [control]="ngControl"></itl-error-display>
</div>

<ion-modal [trigger]="uniqueTriggerId" *ngIf="!freeTextInput">
  <ng-template>
    <ion-content>
      <ion-datetime
        #datePicker
        [(ngModel)]="dateString"
        [min]="minString"
        [max]="maxString"
        (ionChange)="onDateChange()"
        presentation="date"
        showDefaultButtons="true"
        locale="de-DE"
        [firstDayOfWeek]="1"
        color="secondary"
      >
        <span slot="title">{{ title }}</span>
        <ion-buttons slot="buttons">
          <ion-button color="secondary" fill="clear" (click)="cancel(datePicker)">{{
            'CANCEL_BUTTON' | translate
          }}</ion-button>
          <ion-button color="secondary" fill="clear" (click)="confirm(datePicker)">{{
            'DONE_BUTTON' | translate
          }}</ion-button>
        </ion-buttons>
      </ion-datetime>
    </ion-content>
  </ng-template>
</ion-modal>
